import { ERP } from '../_base/endpoint';
import axios from 'axios';

class columnaBalanceService {
    
    /******* QUERIES ******/

    async listar() {
        const response = await axios
            .get(`${ERP}administracion/columna-balance`)
            .then(response => { 
                return response.data; 
            })
            .catch(error => {
                console.log(error);
            });
        return response;
    };
}

export default new columnaBalanceService();